import { Dialog, DialogTitle, DialogContent, DialogContentText } from '@mui/material'
import CustomButton from '../Button/Button';
import AlertIcon from '../../assets/Icons/AlertIcon.svg';
import UndoIcon from '../../assets/Icons/UndoIcon.svg';
import SendEmailIcon from '../../assets/Icons/SendEmailIcon.svg';
import './TrackingDialog.scss';
import { useAppSelector } from '../../store/hooks';
import { RootState } from '../../store';

type TrackingDialogProps = {
  open: boolean;
  onClose: () => void;
  onEmailLogged: () => void;
  clientName: string;
}
const TrackingDialog = ({ open, onClose, onEmailLogged, clientName }: TrackingDialogProps) => {

  const { loading } = useAppSelector((state: RootState) => state.counts)

  return (
    <Dialog open={open} className='trackingDialog'>

      <img src={AlertIcon} alt="icon" className='alertIcon' />

      <DialogTitle className="trackingDialog">
        Log Email Send for {clientName} ?
      </DialogTitle>

      <DialogContent>
        <p>This will remove their invoice from your dashboard and cannot be undone.</p>
      </DialogContent>

      <DialogContentText className='actionBtns'>
        <CustomButton variant='outlined' onClick={onClose}>
          No, Return to Invoice Dashboard
          <img src={UndoIcon} alt={"Icon"} />
        </CustomButton>

        <CustomButton variant='contained' onClick={onEmailLogged} disabled={loading}>
          {loading ? 'Sending...' : 'Yes, Log Email Send'}
          <img src={SendEmailIcon} alt={"Icon"} />
        </CustomButton>
      </DialogContentText>

    </Dialog>
  )

}

export default TrackingDialog
